/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

let proto = {grpcserver: {}};
const COMPILED = false;

goog.exportSymbol('proto.grpcserver.BindedCamera', null, global);
goog.exportSymbol('proto.grpcserver.CameraByPrinterIdRequest', null, global);
goog.exportSymbol('proto.grpcserver.CameraListRequest', null, global);
goog.exportSymbol('proto.grpcserver.CameraStatus', null, global);
goog.exportSymbol('proto.grpcserver.CameraType', null, global);
goog.exportSymbol('proto.grpcserver.ControlCameraRequest', null, global);
goog.exportSymbol('proto.grpcserver.Empty', null, global);
goog.exportSymbol('proto.grpcserver.Frame', null, global);
goog.exportSymbol('proto.grpcserver.FrameStreamRequest', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpcserver.CameraStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpcserver.CameraStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpcserver.CameraStatus.displayName = 'proto.grpcserver.CameraStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpcserver.CameraListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpcserver.CameraListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpcserver.CameraListRequest.displayName = 'proto.grpcserver.CameraListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpcserver.Frame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpcserver.Frame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpcserver.Frame.displayName = 'proto.grpcserver.Frame';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpcserver.FrameStreamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpcserver.FrameStreamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpcserver.FrameStreamRequest.displayName = 'proto.grpcserver.FrameStreamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpcserver.ControlCameraRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpcserver.ControlCameraRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpcserver.ControlCameraRequest.displayName = 'proto.grpcserver.ControlCameraRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpcserver.CameraByPrinterIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpcserver.CameraByPrinterIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpcserver.CameraByPrinterIdRequest.displayName = 'proto.grpcserver.CameraByPrinterIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpcserver.BindedCamera = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpcserver.BindedCamera, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpcserver.BindedCamera.displayName = 'proto.grpcserver.BindedCamera';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpcserver.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpcserver.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpcserver.Empty.displayName = 'proto.grpcserver.Empty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpcserver.CameraStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.grpcserver.CameraStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpcserver.CameraStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.CameraStatus.toObject = function(includeInstance, msg) {
  var obj = {
    frameStreamToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    active: jspb.Message.getFieldWithDefault(msg, 2, false),
    number: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cameraName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    base64: jspb.Message.getFieldWithDefault(msg, 5, false),
    preview: jspb.Message.getFieldWithDefault(msg, 6, ""),
    hostMac: jspb.Message.getFieldWithDefault(msg, 7, ""),
    justHeartbeat: jspb.Message.getFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpcserver.CameraStatus}
 */
proto.grpcserver.CameraStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpcserver.CameraStatus;
  return proto.grpcserver.CameraStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpcserver.CameraStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpcserver.CameraStatus}
 */
proto.grpcserver.CameraStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    let value = '';
    switch (field) {
    case 1:
      value = /** @type {string} */ (reader.readString());
      msg.setFrameStreamToken(value);
      break;
    case 2:
      value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      value = /** @type {number} */ (reader.readUint32());
      msg.setNumber(value);
      break;
    case 4:
      value = /** @type {string} */ (reader.readString());
      msg.setCameraName(value);
      break;
    case 5:
      value = /** @type {boolean} */ (reader.readBool());
      msg.setBase64(value);
      break;
    case 6:
      value = /** @type {string} */ (reader.readString());
      msg.setPreview(value);
      break;
    case 7:
      value = /** @type {string} */ (reader.readString());
      msg.setHostMac(value);
      break;
    case 8:
      value = /** @type {boolean} */ (reader.readBool());
      msg.setJustHeartbeat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpcserver.CameraStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpcserver.CameraStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpcserver.CameraStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.CameraStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameStreamToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getNumber();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCameraName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBase64();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPreview();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getHostMac();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getJustHeartbeat();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string frame_stream_token = 1;
 * @return {string}
 */
proto.grpcserver.CameraStatus.prototype.getFrameStreamToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.grpcserver.CameraStatus.prototype.setFrameStreamToken = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpcserver.CameraStatus.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.grpcserver.CameraStatus.prototype.setActive = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional uint32 number = 3;
 * @return {number}
 */
proto.grpcserver.CameraStatus.prototype.getNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.grpcserver.CameraStatus.prototype.setNumber = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string camera_name = 4;
 * @return {string}
 */
proto.grpcserver.CameraStatus.prototype.getCameraName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.grpcserver.CameraStatus.prototype.setCameraName = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool base64 = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpcserver.CameraStatus.prototype.getBase64 = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.grpcserver.CameraStatus.prototype.setBase64 = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string preview = 6;
 * @return {string}
 */
proto.grpcserver.CameraStatus.prototype.getPreview = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.grpcserver.CameraStatus.prototype.setPreview = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string host_mac = 7;
 * @return {string}
 */
proto.grpcserver.CameraStatus.prototype.getHostMac = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.grpcserver.CameraStatus.prototype.setHostMac = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool just_heartbeat = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpcserver.CameraStatus.prototype.getJustHeartbeat = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.grpcserver.CameraStatus.prototype.setJustHeartbeat = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpcserver.CameraListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.grpcserver.CameraListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpcserver.CameraListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.CameraListRequest.toObject = function(includeInstance, msg) {
  var obj = {
    cameraListToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpcserver.CameraListRequest}
 */
proto.grpcserver.CameraListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpcserver.CameraListRequest;
  return proto.grpcserver.CameraListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpcserver.CameraListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpcserver.CameraListRequest}
 */
proto.grpcserver.CameraListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCameraListToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpcserver.CameraListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpcserver.CameraListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpcserver.CameraListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.CameraListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCameraListToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string camera_list_token = 1;
 * @return {string}
 */
proto.grpcserver.CameraListRequest.prototype.getCameraListToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.grpcserver.CameraListRequest.prototype.setCameraListToken = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpcserver.Frame.prototype.toObject = function(opt_includeInstance) {
  return proto.grpcserver.Frame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpcserver.Frame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.Frame.toObject = function(includeInstance, msg) {
  var obj = {
    frame: msg.getFrame_asB64(),
    justHeartbeat: jspb.Message.getFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpcserver.Frame}
 */
proto.grpcserver.Frame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpcserver.Frame;
  return proto.grpcserver.Frame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpcserver.Frame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpcserver.Frame}
 */
proto.grpcserver.Frame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFrame(value);
      break;
    case 7:
      var value1 = /** @type {boolean} */ (reader.readBool());
      msg.setJustHeartbeat(value1);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpcserver.Frame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpcserver.Frame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpcserver.Frame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.Frame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrame_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getJustHeartbeat();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional bytes frame = 1;
 * @return {!(string|Uint8Array)}
 */
proto.grpcserver.Frame.prototype.getFrame = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes frame = 1;
 * This is a type-conversion wrapper around `getFrame()`
 * @return {string}
 */
proto.grpcserver.Frame.prototype.getFrame_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFrame()));
};


/**
 * optional bytes frame = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFrame()`
 * @return {!Uint8Array}
 */
proto.grpcserver.Frame.prototype.getFrame_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFrame()));
};


/** @param {!(string|Uint8Array)} value */
proto.grpcserver.Frame.prototype.setFrame = function(value) {
  jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bool just_heartbeat = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpcserver.Frame.prototype.getJustHeartbeat = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 7, false));
};


/** @param {boolean} value */
proto.grpcserver.Frame.prototype.setJustHeartbeat = function(value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpcserver.FrameStreamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.grpcserver.FrameStreamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpcserver.FrameStreamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.FrameStreamRequest.toObject = function(includeInstance, msg) {
  var obj = {
    frameStreamToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpcserver.FrameStreamRequest}
 */
proto.grpcserver.FrameStreamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpcserver.FrameStreamRequest;
  return proto.grpcserver.FrameStreamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpcserver.FrameStreamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpcserver.FrameStreamRequest}
 */
proto.grpcserver.FrameStreamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrameStreamToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpcserver.FrameStreamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpcserver.FrameStreamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpcserver.FrameStreamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.FrameStreamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameStreamToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string frame_stream_token = 1;
 * @return {string}
 */
proto.grpcserver.FrameStreamRequest.prototype.getFrameStreamToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.grpcserver.FrameStreamRequest.prototype.setFrameStreamToken = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpcserver.ControlCameraRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.grpcserver.ControlCameraRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpcserver.ControlCameraRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.ControlCameraRequest.toObject = function(includeInstance, msg) {
  var obj = {
    frameStreamToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    stringResolution: jspb.Message.getFieldWithDefault(msg, 2, ""),
    resolutionX: jspb.Message.getFieldWithDefault(msg, 3, ""),
    resolutionY: jspb.Message.getFieldWithDefault(msg, 4, ""),
    resetCamera: jspb.Message.getFieldWithDefault(msg, 5, false),
    cameraType: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpcserver.ControlCameraRequest}
 */
proto.grpcserver.ControlCameraRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpcserver.ControlCameraRequest;
  return proto.grpcserver.ControlCameraRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpcserver.ControlCameraRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpcserver.ControlCameraRequest}
 */
proto.grpcserver.ControlCameraRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrameStreamToken(value);
      break;
    case 2:
      var value1 = /** @type {string} */ (reader.readString());
      msg.setStringResolution(value1);
      break;
    case 3:
      var value2 = /** @type {string} */ (reader.readString());
      msg.setResolutionX(value2);
      break;
    case 4:
      var value3 = /** @type {string} */ (reader.readString());
      msg.setResolutionY(value3);
      break;
    case 5:
      var value4 = /** @type {boolean} */ (reader.readBool());
      msg.setResetCamera(value4);
      break;
    case 6:
      var value5 = /** @type {!proto.grpcserver.CameraType} */ (reader.readEnum());
      msg.setCameraType(value5);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpcserver.ControlCameraRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpcserver.ControlCameraRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpcserver.ControlCameraRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.ControlCameraRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameStreamToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStringResolution();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResolutionX();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getResolutionY();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getResetCamera();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCameraType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string frame_stream_token = 1;
 * @return {string}
 */
proto.grpcserver.ControlCameraRequest.prototype.getFrameStreamToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.grpcserver.ControlCameraRequest.prototype.setFrameStreamToken = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string string_resolution = 2;
 * @return {string}
 */
proto.grpcserver.ControlCameraRequest.prototype.getStringResolution = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.grpcserver.ControlCameraRequest.prototype.setStringResolution = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string resolution_x = 3;
 * @return {string}
 */
proto.grpcserver.ControlCameraRequest.prototype.getResolutionX = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.grpcserver.ControlCameraRequest.prototype.setResolutionX = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string resolution_y = 4;
 * @return {string}
 */
proto.grpcserver.ControlCameraRequest.prototype.getResolutionY = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.grpcserver.ControlCameraRequest.prototype.setResolutionY = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool reset_camera = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpcserver.ControlCameraRequest.prototype.getResetCamera = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.grpcserver.ControlCameraRequest.prototype.setResetCamera = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional CameraType camera_type = 6;
 * @return {!proto.grpcserver.CameraType}
 */
proto.grpcserver.ControlCameraRequest.prototype.getCameraType = function() {
  return /** @type {!proto.grpcserver.CameraType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.grpcserver.CameraType} value */
proto.grpcserver.ControlCameraRequest.prototype.setCameraType = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpcserver.CameraByPrinterIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.grpcserver.CameraByPrinterIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpcserver.CameraByPrinterIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.CameraByPrinterIdRequest.toObject = function(includeInstance, msg) {
  var obj = {
    printerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpcserver.CameraByPrinterIdRequest}
 */
proto.grpcserver.CameraByPrinterIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpcserver.CameraByPrinterIdRequest;
  return proto.grpcserver.CameraByPrinterIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpcserver.CameraByPrinterIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpcserver.CameraByPrinterIdRequest}
 */
proto.grpcserver.CameraByPrinterIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpcserver.CameraByPrinterIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpcserver.CameraByPrinterIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpcserver.CameraByPrinterIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.CameraByPrinterIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string printer_id = 1;
 * @return {string}
 */
proto.grpcserver.CameraByPrinterIdRequest.prototype.getPrinterId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.grpcserver.CameraByPrinterIdRequest.prototype.setPrinterId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpcserver.BindedCamera.prototype.toObject = function(opt_includeInstance) {
  return proto.grpcserver.BindedCamera.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpcserver.BindedCamera} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.BindedCamera.toObject = function(includeInstance, msg) {
  var obj = {
    bindedCamera: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cameraType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpcserver.BindedCamera}
 */
proto.grpcserver.BindedCamera.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpcserver.BindedCamera;
  return proto.grpcserver.BindedCamera.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpcserver.BindedCamera} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpcserver.BindedCamera}
 */
proto.grpcserver.BindedCamera.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBindedCamera(value);
      break;
    case 2:
      var value1 = /** @type {!proto.grpcserver.CameraType} */ (reader.readEnum());
      msg.setCameraType(value1);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpcserver.BindedCamera.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpcserver.BindedCamera.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpcserver.BindedCamera} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.BindedCamera.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBindedCamera();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCameraType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string binded_camera = 1;
 * @return {string}
 */
proto.grpcserver.BindedCamera.prototype.getBindedCamera = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.grpcserver.BindedCamera.prototype.setBindedCamera = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CameraType camera_type = 2;
 * @return {!proto.grpcserver.CameraType}
 */
proto.grpcserver.BindedCamera.prototype.getCameraType = function() {
  return /** @type {!proto.grpcserver.CameraType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.grpcserver.CameraType} value */
proto.grpcserver.BindedCamera.prototype.setCameraType = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpcserver.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.grpcserver.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpcserver.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.Empty.toObject = function(includeInstance, msg) {
  var obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpcserver.Empty}
 */
proto.grpcserver.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpcserver.Empty;
  return proto.grpcserver.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpcserver.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpcserver.Empty}
 */
proto.grpcserver.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpcserver.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpcserver.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpcserver.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpcserver.Empty.serializeBinaryToWriter = function(/*message, writer*/) {
  //var f = undefined;
};


/**
 * @enum {number}
 */
proto.grpcserver.CameraType = {
  UNKNOWN: 0,
  DISABLED: 1,
  DUAL: 2,
  MULTI: 3,
  PI: 4,
  HD: 5
};

goog.object.extend(exports, proto.grpcserver);
